


































































































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { VuetifyConfirmObject } from 'vuetify-confirm';
import { RegionsModule } from '@/store/Settings/RegionsModule';
import PublicHolidayCreate from '@/components/Settings/Regions/PublicHolidayCreate.vue';
import PublicHolidayEdit from '@/components/Settings/Regions/PublicHolidayEdit.vue';
import PublicHoliday from '@/models/Settings/Regions/PublicHoliday';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'RegionPublicHolidays', components: { PublicHolidayCreate, PublicHolidayEdit } })
export default class extends SaascadaVue {

    PermissionUtils = PermissionUtils;
    headers = [
        { text: this.$t('pageText.regions.fields.holidayDate'), width: "30%" },
        { text: this.$t('pageText.regions.fields.name'), width: "60%" }
    ];
    publicHolidaysPage = 1;

    async beforeMount() {
        await this.getPublicHolidays();
    }

    async getPublicHolidays() {
        await RegionsModule.getPublicHolidays(this.$route.params.id);
    }

    @Watch('publicHolidaysPage')
    async onPublicHolidaysPageChanged() {
        // Preselect the first row on the next page
        // NOTE: This is only needed when paginating locally through results
        const nextItemIndex = (this.publicHolidaysPage - 1) * this.pageSize;
        const nextItem = this.publicHolidays[nextItemIndex];
        await RegionsModule.updateCurrentPublicHoliday(nextItem);
    }

    async updateCurrentPublicHoliday(publicHoliday: PublicHoliday) {
        await RegionsModule.updateCurrentPublicHoliday(publicHoliday);
    }

    get publicHolidays() {
        return RegionsModule.publicHolidays;
    }

    get totalPublicHolidaysPages() {
        return RegionsModule.totalPublicHolidaysPages;
    }

    get currentPublicHoliday() {
        return RegionsModule.currentPublicHoliday;
    }

    get loading() {
        return RegionsModule.loadingPublicHolidays;
    }

    get pageSize() {
        return RegionsModule.pageSize;
    }

    async deletePublicHoliday() {
        const options: VuetifyConfirmObject = {
            buttonTrueText: "Delete",
            buttonFalseText: "Close",
            buttonTrueColor: "primary",
            buttonFalseColor: "primary",
        }
        const result = await this.$confirm('Are you sure you want to delete this public holiday?', options);
        if (result) {
            await RegionsModule.deletePublicHoliday();
            await this.getPublicHolidays();
        }
    }

}
